import React from "react";
import { App as AntdApp } from "antd";
import { AuthProvider } from "../../hooks/useAuth";
import { TimeZoneProvider } from "../../contexts/TimeZoneContext";

const AppProviders = ({ children }) => {
    const { message } = AntdApp.useApp();

    return (
        <AuthProvider messageApi={message}>
            <TimeZoneProvider>{children}</TimeZoneProvider>
        </AuthProvider>
    );
};

export default AppProviders;
